import { Vendor } from "@safetyculture/s12-apis-connect-web/s12/iot/v1/vendor_pb";

export const VendorMap = {
  [Vendor.UNKNOWN]: "Unknown",
  [Vendor.MONNIT]: "Monnit",
  [Vendor.PIXEL]: "Pixel",
  [Vendor.S12TEST]: "S12Test",
  [Vendor.BYO_MONNIT]: "BYO Monnit",
  [Vendor.ACCUWEATHER]: "AccuWeather",
  [Vendor.DEFINIUM]: "Definium",
  [Vendor.NNNCO]: "NNNCo",
  [Vendor.MYDEVICES]: "MyDevices",
};

export const SignalStrengthHelpURL =
  "https://safetyculture.atlassian.net/wiki/spaces/IOT/pages/2759131556/Support+Interpreting+Signal+Strength";

export const SensorAlertCSVExportURL =
  "https://safetyculture.atlassian.net/wiki/spaces/IOT/pages/2934867916/Periscope+sensor+alert+CSV+export+explained.";

// The SignalStrengthMap is used to define signal bands in terms of "unusable", "bad" and "good". Anything above "good"
// is considered "excellent"
export const SignalStrengthMap: {
  [name: string]: {
    [band: string]: number;
  };
} = {
  Monnit: {
    poor: 39,
    intermittent: 49,
    good: 69,
  },
  "BYO Monnit": {
    poor: 39,
    intermittent: 49,
    good: 69,
  },
  MyDevices: {
    poor: -111,
    intermittent: -101,
    good: -90,
  },
  Definium: {
    poor: -111,
    intermittent: -101,
    good: -90,
  },
  S12Test: {
    poor: -111,
    intermittent: -101,
    good: -90,
  },
};

export enum KnownUnits {
  Boolean = "Boolean",
  Counter = "Counter",
  Integer = "Integer",
  Celsius = "Celsius",
  Fahrenheit = "Fahrenheit",
  Decibel = "Decibel",
  DecibelMilliwatt = "DecibelMilliwatt",
  Digital = "Digital",
  Lux = "Lux",
  Microgram = "Microgram",
  Millivolt = "Millivolt",
  PartPerMillion = "PartPerMillion",
  Pascal = "Pascal",
  Percentage = "Percentage",
  Volt = "Volt",
  MicrogramPerCubicMeter = "MicrogramPerCubicMeter",
  UnixTime = "UnixTime",
}

export const readingUnitToSymbolString = new Map<KnownUnits, string>([
  [KnownUnits.Celsius, "˚C"],
  [KnownUnits.Fahrenheit, "˚F"],
  [KnownUnits.Decibel, "dB"],
  [KnownUnits.DecibelMilliwatt, "dBm"],
  [KnownUnits.Lux, "lx"],
  [KnownUnits.Microgram, "μg"],
  [KnownUnits.Millivolt, "mV"],
  [KnownUnits.PartPerMillion, "ppm"],
  [KnownUnits.Pascal, "Pa"],
  [KnownUnits.Percentage, "%"],
  [KnownUnits.Volt, "V"],
  [KnownUnits.MicrogramPerCubicMeter, "μg/m³"],
  [KnownUnits.UnixTime, ""],
  [KnownUnits.Digital, ""],
  [KnownUnits.Boolean, ""],
  [KnownUnits.Counter, ""],
  [KnownUnits.Integer, ""],
]);
